<template>
	<div>
		<!-- <b-col cols="12">
				<slot v-if="hasHeaderSlot" name="header"></slot>
				<h2 v-else>{{ $t('foods.categories.title')}}</h2>
		</b-col> -->
		<b-row class="neu-cards-ctn landing-cnt  mt-5" cols="1" cols-xl="4">
			<PatientPanelServiceBlock id="my-microhabits" visible :title="myMicrohabitsTitles[type]" :description="myMicrohabitsDescription[type]" :action="() => $router.push(`/patient/${microhabitTypeName}/favorites`)" :img="`/static-appopensalud/img/icons/morillas-svg-icons/primary/heart.svg`" :backgroundColor="GREEN_COLOUR" :textAndIconColor="BLACK_COLOUR" only360Users :toggleableMobileDescription="false" :hideArrowMobileButton="true">
				<template v-slot:footer>
					<span class="d-block mt-3">
						<BBadge variant="info" v-b-tooltip.hover.bottom="$t('patients.microhabits.selected')">{{ favouritesNumber }}</BBadge>
						<BBadge variant="primary" v-b-tooltip.hover.bottom="$t('patients.microhabits.achieved')">{{ achievedNumber }}</BBadge>
					</span>
				</template>
			</PatientPanelServiceBlock>
			<PatientPanelServiceBlock v-for="category in categories" visible :id="category.id" :key="category.id" :title="$i18nHelpers.normalize(category.name)" :action="() => { goToMicrohabits(category)}" :img="category.icon" />
		</b-row>
	</div>
</template>

<script>
import PatientPanelServiceBlock from '@/components/PatientPanelServiceBlock'
import microhabitsMixin from '@/mixins/microhabits.mixin'
import { GREEN_COLOUR, BLACK_COLOUR } from '@/constants/colours'
import { MICROHABIT_SIMPLE_TYPE, MICROHABIT_FOOD_TYPE } from '@/constants/microhabitTypes'
import { BBadge } from 'bootstrap-vue'

export default {
	mixins: [microhabitsMixin],
	components: {
		PatientPanelServiceBlock,
		BBadge
	},
	data () {
		return {
			categories: [],
			GREEN_COLOUR,
			BLACK_COLOUR,
			patientMicrohabits: []
		}
	},
	computed: {
		hasHeaderSlot () {
			return !!this.$slots.header
		},
		myMicrohabitsTitles () {
			return {
				[MICROHABIT_SIMPLE_TYPE]: this.$t('patient-panel.my-microhabits'),
				[MICROHABIT_FOOD_TYPE]: this.$t('patient-panel.my-foods')
			}
		},
		myMicrohabitsDescription () {
			return {
				[MICROHABIT_SIMPLE_TYPE]: this.$t('microhabits.simple.categories-menu.title'),
				[MICROHABIT_FOOD_TYPE]: this.$t('foods.categories.title')
			}
		},
		favouritesNumber () {
			return this.patientMicrohabits.length
		},
		achievedNumber () {
			return this.patientMicrohabits.filter(microhabit => microhabit.achieved).length
		}
	},
	methods: {
		goToMicrohabits (category) {
			this.$router.push(`/patient/${this.microhabitTypeName}/${category.id}`)
		}
	},
	mounted () {
		this.microhabitRepository.getMicrohabitCategories().then((response) => {
			// Sort by name
			response.data.sort((a, b) => this.$i18nHelpers.normalize(a.name).localeCompare(this.$i18nHelpers.normalize(b.name)))
			this.categories = response.data
		})

		if (this.favoritesSectionActive) {
			this.microhabitRepository.getPatientMicrohabits().then((response) => {
				if (!response.data) {
					return
				}
				this.patientMicrohabits = response.data
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../../../static-appopensalud/css/webapp/foods-section.scss';
</style>


// WEBPACK FOOTER //
// src/components/microhabits/MicrohabitCategoriesPanelMenu.vue